import { LockKeyhole, Sparkles } from "lucide-react";

export function PaymentBanner({ loading, pending, onUnlock }: { loading: boolean; pending?: boolean; onUnlock: () => void }) {
  return (
    <div className="rounded-[2rem] bg-coral p-6 text-ink shadow-soft md:flex md:items-center md:justify-between md:p-9">
      <div className="flex gap-4">
        <div className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-ink text-lime"><LockKeyhole /></div>
        <div>
          <p className="text-xs font-extrabold uppercase tracking-[.2em]">₹499 • Three full-report uses</p>
          <h2 className="mt-2 font-display text-3xl">Your complete action plan is ready.</h2>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-ink/70">Unlock this report plus two future full reports. Pay securely through Razorpay using UPI Intent, UPI QR, Indian credit or debit cards, and other methods enabled for your account.</p>
        </div>
      </div>
      <button className="btn-dark mt-6 w-full md:mt-0 md:w-auto" disabled={loading || pending} onClick={onUnlock}>
        <Sparkles size={17} /> {pending ? "Verification pending" : loading ? "Preparing…" : "Unlock for ₹499"}
      </button>
    </div>
  );
}
